<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0; padding-top: 10px">
      <v-row class="text-start">
        <v-col md="12">
          <v-card flat class="text-right v-card-bg-none">
            <v-card-actions>
              <v-btn color="secondary" outlined class="mr-1 btn btn-primary add-course-button text-right  " :to="this.$store.getters.admin ? '/admin/courses' : '/course-library'">
                <v-icon class="mr-1" small>fa-chevron-left</v-icon>
                 {{ this.$store.getters.admin ? 'Back to Course Lists' : 'Back to Course Library' }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="loading" fluid class="pt-8">
      <v-row justify="center" align="center">
        <v-col align="center" class="pa-0 col-md-10 col-sm-10 col-xs-12">
          <div class="course-title-wrapper mb-4">
            <div class="course-title skeleton-box" style="width: 100%; height: 16px;"></div>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col align="center" class="pa-0 col-md-6 col-sm-6 col-xs-12">
          <v-list-item v-for="index in 3" :key="index">
            <div class="course-description skeleton-box" style="width: 100%; height: 16px;"></div>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col md="10">
          <div>
            <div class="course-duration">
              Duration:
              <div class="course-description skeleton-box" style="width: 100%; height: 16px;"></div>
            </div>
            <div class="course-status">
              Status:<div class="course-description skeleton-box" style="width: 100%; height: 16px;"></div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col class="col-md-8 col-sm-8 col-xs-8">
          <v-skeleton-loader class="mx-auto border" type="image"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col md="8" align="left">
          <v-skeleton-loader class="mx-auto" type="heading"></v-skeleton-loader>
          <v-skeleton-loader class="mx-auto mt-5" type="sentences"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" class="mb-5">
        <v-col md="8">
          <h2 class="mb-2 font-20">Course Content</h2>
          <v-list-item style="border: 1px solid #ccc;">
            <div class="skeleton-box" style="width: 50px; height: 24px;"></div>
            <div class="skeleton-box ml-5" style="width: 50px; height: 24px;"></div>
          </v-list-item>
          <v-list-item v-for="index in 4" :key="index" style="border: 1px solid #ccc;">
            <div class="skeleton-box notification-state-box" style="width: 25px; height: 24px;"></div>
            <div class="skeleton-box notification-state-box" style="width: 25px; height: 24px;"></div>
            <v-list-item-content>
              <div class="skeleton-box" style="width: 70%; height: 16px;"></div>
            </v-list-item-content>
            <v-list-item-action style="align-items: center;">
              <div class="skeleton-box" style="width: 60px; height: 30px;"></div>
            </v-list-item-action>
          </v-list-item>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid v-else>
      <v-row justify="center" align="center">
        <v-col align="center" class="pa-0 col-md-10 col-sm-10 col-xs-12">
          <div class="course-title-wrapper mb-4">
            <p class="course-title">
              {{ course.name }}
            </p>
            <v-tooltip v-if="course.is_membership" bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on" class='isMember-Title'></div>
              </template>
              <span>Membership Content</span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col align="center" class="pa-0 col-md-6 col-sm-6 col-xs-12">
          <div class="course-description" @click="handleLinkClick" v-html="course.description"></div>
        </v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col md="10">
          <div>
            <div class="course-duration">Duration: {{ duration }} mins</div>
            <!--<div class="course-status" v-if="course.enrolled">
              Status: {{course.enrolled.data.state_text}}
            </div>-->
            <div class="course-status">Status: {{ status }}</div>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="hasVideos" justify="center" align="center">
        <v-col class="col-md-8 col-sm-8 col-xs-8">
          <ViewVideoPlayer />
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="hasVideos">
        <v-col md="8" align="left">
          <h2>{{ selectedVideo.title }}</h2>
          <p class="video-item-description">{{ selectedVideo.description }}</p>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="isPpt">
        <PptPlayer />
      </v-row>
      <v-row justify="center" align="center" v-if="isScorm">
        <v-col class="col-md-8 col-sm-8 col-xs-8">
          <ScormPlayer :item="course.scorm.data[0].file.data" />
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="
          hasVideos ||
          externalLink ||
          course.documents.data.length > 0 ||
          isPpt ||
          isScorm
        ">
        <v-col md="8">
          <h2 class="mb-2 font-20">Course Content</h2>
          <v-card class="mb-5 vcard-border">
            <v-list two-line class="pb-0">
              <v-list-item-group>
              <v-list-item two-line class="videoitem-content-th">
                <template class="vcard-list">
                  <v-list-item-title style="width: 135px; flex: none">
                    Status
                  </v-list-item-title>
                  <v-list-item-title style="text-align: left">
                    Title
                  </v-list-item-title>
                  <v-list-item-title> &nbsp; </v-list-item-title>
                </template>
              </v-list-item>
          </v-list-item-group>
          </v-list>
            <ViewSupplementalDocumentation> </ViewSupplementalDocumentation>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import ViewSupplementalDocumentation from '@/pages/authenticated/courses/ViewSupplementalDocumentation';
import ViewVideoPlayer from '@/pages/authenticated/courses/ViewVideoPlayer';
import courseAPI from '@/api/course.js';
import PptPlayer from '@/pages/authenticated/courses/PptPlayer';
import ScormPlayer from '@/pages/authenticated/courses/ScormPlayer';
export default {
  name: 'ShowCourseDetail',
  components: {
    LayoutBasic,
    ViewSupplementalDocumentation,
    ViewVideoPlayer,
    PptPlayer,
    ScormPlayer,
  },
  data() {
    return {
      completed: false,
      deadlinePassed: false,
      eventType: 1,
      loading: false,
      totalEvents: 0,
      id: this.$route.params.id,
      params:
        '?include=thumbnail,enrolled,videos,documents,test,links,ppts,scorm',
      links: [],
      ppts: [],
      scorm: [],
    };
  },
  computed: {
    selectedTopics() {
      return this.course.topics.data.map((x) => {
        return x.tag;
      });
    },
    totalVideos: function () {
      return this.course.total_videos;
    },
    multiVideo: function () {
      return this.course.videos.data.length > 1 ? true : false;
    },
    selectedVideo: function () {
      return this.$store.getters.currentVideo;
    },
    course: function () {
      return this.$store.getters.coursePlayer;
    },
    mimeType() {
      return this.selectedVideo.file.hasOwnProperty('data')
        ? this.selectedVideo.file.data.mime_type
        : this.selectedVideo.file.mime_type;
    },
    hasTopics: function () {
      if (
        this.course.topics != null &&
        this.course.topics.hasOwnProperty('data') &&
        this.course.topics.data.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    hasVideos: function () {
      if (
        this.course.videos != null &&
        this.course.videos.hasOwnProperty('data') &&
        this.course.videos.data.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    externalLink: function () {
      return this.course.links.data.length > 0 ? true : false;
    },
    selectedPpt: function () {
      return this.$store.getters.currentPpt;
    },
    isPpt: function () {
      return this.course.ppts.data.length > 0 ? true : false;
    },
    duration: function () {
      if (this.course.hours != 0) {
        return this.course.hours * 60 + this.course.minutes;
      } else {
        return this.course.minutes;
      }
    },
    isScorm: function () {
      return this.course.scorm.data.length > 0 ? true : false;
    },
    selectedScorm: function () {
      return this.$store.getters.currentScorm;
    },
    status:function(){
        return this.course.published ? 'Published' : 'Not Published';
    }
  },
  mounted() {
    this.getCourse(this.id);
    this.$store.dispatch('setPlayVideo', false);
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    getCourse(id) {
      this.loading = true;
      courseAPI
        .getCourse(
          id,
          '?include=videos,documents,links,ppts,scorm'
        )
        .then((response) => {
          this.links = response.data.data.links.data;
          this.ppts = response.data.data.ppts.data;
          this.scorm = response.data.data.scorm.data;
          this.$store.dispatch(
            'setCoursePreviewCoursePlayer',
            response.data.data
          );
          this.loading = false;
        });
    },
    handleLinkClick(event) {
      // Check if the clicked element is a link
      if (
        event.target.tagName === 'A' ||
        event.target.parentElement.tagName === 'A'
      ) {
        // Prevent the default action of the click event
        event.preventDefault();
        // Get the link URL
        const linkUrl =
          event.target.tagName === 'A'
            ? event.target.href
            : event.target.parentElement.href;
        // Open the link URL in a new tab
        window.open(linkUrl, '_blank');
      }
    },
  },
};
</script>
<style>
.isMember-Title{
  background-color: #83c902;
  height: 30px;
  width: 35px;
  border-radius: 7px;
  display: flex;
  justify-content: center;
}

.isMember-Title::after {
  content: "";
  width: 20px;
  height: 20px;
  margin: 6px 2px 5px 0;
  background-image: url(/static/safeguarding-stars.png);
  background-size: contain;
  background-repeat: no-repeat;
  display: block;
}

.v-application p{
  margin: 0;
}

.course-title-wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 1em;
}
</style>